import { useWorkflowsForRecipientByType } from '@/hooks/use-workflows';
import { getWorkflowPackClass } from '@/utils/workflows';
import { useClinicalPacks } from '..';

export function useAllClinicalPacks(circleId: number, isOrdered = false) {
    const { workflows } = useWorkflowsForRecipientByType({
        circleId,
        workflowType: 'clinical_program',
    });

    return useClinicalPacks(
        circleId,
        workflows?.reduce((packClasses: string[], workflow) => {
            const packClass = getWorkflowPackClass(workflow);

            return packClass ? [...packClasses, packClass] : packClasses;
        }, []),
        isOrdered
    );
}
